/** @format */

import React, { FC, useState, useEffect, useRef } from 'react'
import { QueryCostOptSub, QueryCostList } from './GeneralApi'
import { SubjectCost } from 'src/api/ApiGeneral'
import { Checkbox, Input, Form, FormItem, Message, Dialog, _$ } from 'kpc-react'
import styled from 'styled-components'

interface OwnProps {
  className?: string
}

const OrderContent: FC<OwnProps> = ({ className }) => {
  const [show, setOrder] = useState<boolean>()
  const [costDict, setCostDict] = useState<{
    periods: string[]
    productTypes: string[]
    emails: string
  }>({
    periods: ['weekly', 'monthly'],
    emails: '',
    productTypes: []
  })
  const [products, setProducts] = useState(undefined)
  const orderForm = useRef({
    validate: function () {
      return ''
    }
  })

  useEffect(() => {
    if (!show) return
    Promise.all([QueryCostOptSub(), QueryCostList()]).then(res => {
      if (res[0]?.code === 'Success' && res[1]?.code === 'Success') {
        const costOpts = res[0]?.data?.data
        const costList = res[1]?.data?.data
        setProducts(costList?.productList || [])
        setCostDict(state => ({
          ...state,
          ...costOpts
        }))
      } else if (res[0]?.code !== 'Success') {
        Message.warning(res[0]?.message)
      } else {
        Message.warning(res[1]?.message)
      }
    })
  }, [show])
  const timeCheck = [
    {
      label: _$('每周'),
      value: 'weekly'
    },
    {
      label: _$('每月'),
      value: 'monthly'
    }
  ]

  const addProducts = typeid => {
    const productTypes = costDict?.productTypes
    productTypes.push(typeid)
    setCostDict(state => ({
      ...state,
      productTypes
    }))
  }
  const delProduct = typeid => {
    let productTypes = costDict?.productTypes
    productTypes = productTypes.filter(i => i !== typeid)
    setCostDict(state => ({
      ...state,
      productTypes
    }))
  }

  const onOk = async dialog => {
    const result = await orderForm.current.validate()
    if (result) {
      dialog.showLoading()
      SubjectCost(costDict).then(res => {
        dialog.hideLoading()
        if (res?.code === 'Success') {
          Message.success(res?.message)
          setOrder(false)
        }
      })
    }
  }
  return (
    <div>
      <a
        onClick={() => {
          setOrder(true)
        }}
      >
        {_$('订阅数据')}
      </a>
      <Dialog
        width={660}
        value={show}
        on$change-value={(c, show) => {
          setOrder(show)
        }}
        ok={onOk}
        title={_$('订阅数据')}
      >
        <Form ref={orderForm} className={className} labelWidth={160}>
          <FormItem label={_$('报告周期')}>
            {Array.isArray(timeCheck) &&
              timeCheck.map(i => (
                <Checkbox
                  className="check-item"
                  key={i.value}
                  value={costDict?.periods && costDict?.periods.includes(i.value) ? true : false}
                  onChange={value => {
                    let periods = costDict.periods
                    value
                      ? !periods.includes(i.value) && periods.push(i.value)
                      : (periods = periods.filter(el => el !== i.value))
                    setCostDict(state => ({ ...state, periods: periods }))
                  }}
                >
                  {i.label}
                </Checkbox>
              ))}
          </FormItem>
          <FormItem label={_$('订阅指标')}>
            {products?.length > 0 ? (
              products.map((i, index) => (
                <Checkbox
                  className="check-item"
                  key={i?.productType || index}
                  value={
                    costDict?.productTypes && costDict?.productTypes.includes(i.productType)
                      ? true
                      : false
                  }
                  onChange={value => {
                    value ? addProducts(i.productType) : delProduct(i.productType)
                  }}
                >
                  {i.productName}
                </Checkbox>
              ))
            ) : (
              <p>{_$('订阅指标为空，指标不会被订阅')}～</p>
            )}
          </FormItem>
          <FormItem
            value={costDict.emails}
            label={_$('接收邮箱')}
            rules={{ required: true, verifyAdress: true }}
          >
            <Input
              value={costDict.emails}
              placeholder={_$('请填写邮箱地址')}
              onChange={e => {
                setCostDict(state => ({ ...state, emails: e.target.value }))
              }}
            ></Input>
          </FormItem>
        </Form>
      </Dialog>
    </div>
  )
}
export default styled(OrderContent)`
  .k-checkbox .k-text {
    margin-left: 2px !important;
  }
  .check-item {
    margin-right: 12px;
  }
`
